import _ from 'lodash';
import ItemComponent from "../../../../core/infraestructure/ItemComponent";
import CourseDetailViewModel from "../../../../core/features/course/viewmodels/CourseDetailViewModel";

export default {
  extends: ItemComponent,
  data() {
    return {
      viewModel: null,
      activityPreview: null,
      modalItemCoursePublicActivity: {
        isVisible: false,
        isLoading: false,
      },
    };
  },
  props: {
    courseSubject: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.viewModel = new CourseDetailViewModel(this);
  },
  methods: {
    orderActivities(collection) {
      return _.sortBy(collection, "sort");
    },
    onShowPublicActivity(activity) {
      this.activityPreview = activity;
      this.viewModel.showModal(this.modalItemCoursePublicActivity, true);
    },
    getActivityIcon(activity) {
      if (activity.hasVideo) return "uil uil-play-circle";
      if (activity.hasFile) return "uil uil-file-download-alt";
      if (activity.hasMultipleResponse || activity.hasOpenResponse) return "uil uil-file-check-alt";
      return "uil uil-file-alt";
    },
  },
};
